// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  pendingResources: false,
  // apiUrlOld: 'https://cube-mia.com/cubeapi/api',
  apiUrl: 'http://192.168.0.33/api2/api2',
  //Variables Config
  //apiBaseUrl: "https://devapi.cube-usa.com/api6",
  // dateFormat: "MM/dd/yyyy",
  // moneyFormat: "$", 
  // videoDashboardSelected: "https://www.google.com/",
  // videoDashboardUnSelected: "https://www.amazon.com/",
  // whatsNewURL: "https://www.amazon.com/",
  urlInformation: "https://wsapi.foresightgps.com/ForesightFlexAPI.ashx?",
  quickbooksurl: "https://qbapi.cube-usa.com/",

  // apiMasterVendorUrl: "http://cube-mia.com/alpsapi/Apls/api",
  // userName: "qa@sfc-mia.com", //
  // pass: "123456", //
  fleetuserid: "487",
  conncode: "PolarixUSA",
  polarixapiuser: "terpel",
  polarixapipass: "fsgpsTerpel",
  // reportingURL: "http://localhost:1908/",
  // LinkGettingStarted: "https://cube-usa.com/",
  // LinkCubeFlow: "https://cube-usa.com/",
  // LinkWhatsNew: "https://amazon.com/",
  // dashboardURL: "https://localhost:44376/",
  // newdashboardURL: "https://cubebi.cube-usa.com/",
  // UseNewDashboard: "false",
  // websocketserverURL:"wss://cubewss.polarix.com:8444",
  // cubeAIserverURL: "http://cubewss.polarix.com:8447/cubeai/:",

  DashboardComponentsType: {
    table: 1,
    doughnut: 2,
    pie: 3,
    bar: 4,
    barHorizontal: 5,
    Stacked: 6,
    indicator: 7,
    indicator2: 8,
    line: 9,
    radar: 10
  },
  DataTableFiltersType: {
    InputTypeNumber: 1,
    InputTypeText: 2,
    DropDown: 3,
    DatePicker: 4,
    DatePickerRange: 5
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
